/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum MaintenanceComponentDueState {
    NEXT = 'NEXT',
    DUE = 'DUE',
    OVERDUE = 'OVERDUE',
    UNKNOWN = 'UNKNOWN',
}

export enum ComponentType {
    MAINTENANCE_COMPONENT = 'MAINTENANCE_COMPONENT',
    CUSTOM_COMPONENT = 'CUSTOM_COMPONENT',
}

export enum MaintenanceStatus {
    OVERDUE = 'OVERDUE',
    DUE = 'DUE',
    NEXT = 'NEXT',
    UNKNOWN = 'UNKNOWN',
}

export enum PhoneType {
    PHONE_TYPE_LAND_LINE = 'PHONE_TYPE_LAND_LINE',
    PHONE_TYPE_MOBILE = 'PHONE_TYPE_MOBILE',
}

export enum Status {
    NORMAL = 'NORMAL',
    WARNING = 'WARNING',
    DANGER = 'DANGER',
    UNKNOWN = 'UNKNOWN',
}

export enum AxleSide {
    LEFT = 'LEFT',
    RIGHT = 'RIGHT',
}

export enum AxlePosition {
    FRONT_AXLE = 'FRONT_AXLE',
    REAR_AXLE_1 = 'REAR_AXLE_1',
    REAR_AXLE_2 = 'REAR_AXLE_2',
    REAR_AXLE_3 = 'REAR_AXLE_3',
    REAR_AXLE_4 = 'REAR_AXLE_4',
    REAR_AXLE_5 = 'REAR_AXLE_5',
    REAR_AXLE_6 = 'REAR_AXLE_6',
    REAR_AXLE_7 = 'REAR_AXLE_7',
    REAR_AXLE_8 = 'REAR_AXLE_8',
    REAR_AXLE_9 = 'REAR_AXLE_9',
    REAR_AXLE_10 = 'REAR_AXLE_10',
    REAR_AXLE_11 = 'REAR_AXLE_11',
    REAR_AXLE_12 = 'REAR_AXLE_12',
    RESERVE_WHEELS = 'RESERVE_WHEELS',
}

export enum BusinessType {
    SERVICE_PARTNER = 'SERVICE_PARTNER',
    IMPORTER = 'IMPORTER',
    WORKSHOP = 'WORKSHOP',
    NSC = 'NSC',
}

export interface BrakePageResponse {
    content: Brake[];
    page: PageMetadata;
}

export interface GroupedBrakePageResponse {
    content: GroupedBrake[];
    page: PageMetadata;
}

export interface PageMetadata {
    /** @format int32 */
    page_size: number;
    /** @format int32 */
    page_number: number;
    /** @format int64 */
    total_elements: number;
    /** @format int32 */
    total_pages: number;
}

export interface Brake {
    axle_position?: AxlePosition;
    axle_side?: AxleSide;
    /** @format float */
    value?: number;
    status?: Status;
    /** Unique identifier of each resource e.g a brake-lining resource or maintenance-component. It can also be a component_id. */
    resource_id: ResourceId;
    account: Account;
    workshop?: Workshop;
    asset: Asset;
    measured_at: MeasuredAt;
}

export interface Account {
    /**
     * Usually a UUID, but non-UUID values may occur; treat as string.
     * @format uuid
     */
    id: string;
    name: string;
}

export interface Workshop {
    id: string;
    name: string;
    workshop_address?: Address;
    business_type?: BusinessType;
    is_training?: boolean;
}

export interface Asset {
    /** @format uuid */
    id: string;
    name: string;
    vin: string;
}

export interface LatestEventPageResponse {
    content: LatestEvent[];
    page: PageMetadata;
}

export interface LatestEvent {
    asset: Asset;
    measured_at: MeasuredAt;
}

export interface MeasuredAt {
    /** @format date-time */
    timestamp: string;
    /** @format float */
    mileage?: number;
}

/**
 * Unique identifier of each resource e.g a brake-lining resource or maintenance-component. It can also be a component_id.
 * @format uuid
 * @example "23cc75a4-a848-4db1-a322-e0606024b92c"
 */
export type ResourceId = string;

/** Details of the vehicle assignment. */
export interface Assignment {
    /** @format uuid */
    asset_id: string;
    workshop_id: string;
    /** The user from the fleet account who is also the contact person for the vehicle. */
    contact_person: ContactPerson;
    /** Fleet account the vehicle is part of. */
    fleet_account: FleetAccount;
}

/** The user from the fleet account who is also the contact person for the vehicle. */
export interface ContactPerson {
    /** @format uuid */
    id: string;
    name: string;
    email?: string;
    phone_numbers: PhoneNumber[];
}

/** Fleet account the vehicle is part of. */
export interface FleetAccount {
    id: string;
    name?: string;
    address?: Address;
}

export interface Address {
    street?: string;
    city?: string;
    zip?: string;
    /** @example "DE" */
    country_code?: string;
}

/** @example {"number":"+49 30 123456789","type":"PHONE_TYPE_LAND_LINE"} */
export interface PhoneNumber {
    /** @example "+49 30 123456789" */
    number: string;
    type: PhoneType;
}

export interface BrakeLiningSettings {
    columns: BrakeLiningColumns;
    filters: BrakeLiningFilters;
    sort: Sorting;
}

export interface BrakeLiningColumns {
    /** @example true */
    vehicle: boolean;
    /** @example false */
    vin: boolean;
    /** @example true */
    customer: boolean;
    /** @example false */
    workshop?: boolean;
}

export interface BrakeLiningFilters {
    /** @example 10 */
    min?: number;
    /** @example 50 */
    max?: number;
    /** @example ["DANGER","WARNING"] */
    status?: Status[];
}

export interface MaintenanceDataSettings {
    columns: MaintenanceDataColumns;
    /**
     * Whether the filters panel is expanded
     * @example true
     */
    show_filters?: boolean | null;
    filters: MaintenanceDataFilters;
    sort: Sorting;
}

export interface MaintenanceDataColumns {
    /**
     * Show VIN column
     * @example true
     */
    vin: boolean;
    /**
     * Show customer column
     * @example true
     */
    customer: boolean;
    /**
     * Show vehicle name column
     * @example true
     */
    vehicle: boolean;
    /**
     * Show workshop column (visible only for admin roles)
     * @example false
     */
    workshop?: boolean | null;
    /**
     * Show due state column
     * @example true
     */
    due_state: boolean;
    /**
     * Show workshop appointment column
     * @example true
     */
    workshop_appointment: boolean;
}

export interface MaintenanceDataFilters {
    /**
     * Minimum due-in mileage (km)
     * @example 1000
     */
    from_due_in?: number | null;
    /**
     * Maximum due-in mileage (km)
     * @example 50000
     */
    to_due_in?: number | null;
    /**
     * Start of due-at date range
     * @format date-time
     * @example "2026-01-01T00:00:00Z"
     */
    from_due_at?: string | null;
    /**
     * End of due-at date range
     * @format date-time
     * @example "2026-12-31T23:59:59Z"
     */
    to_due_at?: string | null;
    /**
     * Predefined date range shortcut
     * @example "NEXT_MONTH"
     */
    preset_date?: 'TODAY' | 'NEXT_WEEK' | 'NEXT_MONTH' | 'CUSTOM' | null;
    /**
     * When true, filters by date OR mileage. When false/null, filters by date AND mileage.
     * @example true
     */
    use_date_or_mileage?: boolean | null;
    /**
     * Filter by maintenance status values
     * @example ["OVERDUE","DUE"]
     */
    maintenance_status?: MaintenanceStatus[] | null;
    /**
     * Selected maintenance component IDs.
     * @example ["12","11","32"]
     */
    maintenance_component?: string[] | null;
    /**
     * Filter by component type
     * @example ["MAINTENANCE_COMPONENT"]
     */
    component_types?: ComponentType[] | null;
    mileage_range?: MileageRange;
    /**
     * Free-text search filter
     * @example null
     */
    search_text?: string | null;
    /**
     * When true, shows only proactive maintenance items
     * @example true
     */
    show_only_pro_active_maintenance?: boolean | null;
    /**
     * When true, returns only items marked as solved by the customer. When false or null, the filter is not applied (both solved and unsolved items are returned).
     * @example false
     */
    solved_by_customer?: boolean | null;
}

export type MileageRange = {
    /**
     * Minimum mileage (km)
     * @example 10000
     */
    from_mileage?: number | null;
    /**
     * Maximum mileage (km)
     * @example 200000
     */
    to_mileage?: number | null;
};

export interface Sorting {
    /** @example "vehicle" */
    sort_by?: string;
    /** @example "ASC" */
    sort_direction?: 'ASC' | 'DESC';
}

export interface GroupedBrake {
    axle_position?: AxlePosition;
    left?: BrakeSideData;
    right?: BrakeSideData;
    account: Account;
    workshop?: Workshop;
    asset: Asset;
}

export interface BrakeSideData {
    /** @format float */
    value: number;
    status: Status;
    /** Unique identifier of each resource e.g a brake-lining resource or maintenance-component. It can also be a component_id. */
    resource_id: ResourceId;
    /** @format date-time */
    timestamp?: string;
    /** @format float */
    mileage?: number;
}

export interface MaintenanceDataSearchRequest {
    /**
     * @min 1
     * @max 100
     * @default 20
     */
    page_size?: number;
    /**
     * @min 0
     * @default 0
     */
    page_number?: number;
    /** @default "vehicle" */
    sort_by?:
        'vehicle' | 'vin' | 'customer' | 'workshop' | 'status' | 'component' | 'due_at' | 'due_in' | 'appointment';
    /**
     * Accepted values: ASC, DESC (case-insensitive). Unrecognized values default to ASC.
     * @default "ASC"
     */
    sort_direction?: string;
    asset_ids?: string[];
    account_ids?: string[];
    workshop_ids?: string[];
    status?: ('NEXT' | 'DUE' | 'OVERDUE' | 'UNKNOWN')[];
    component_type?: ('MAINTENANCE_COMPONENT' | 'CUSTOM_COMPONENT')[];
    component?: string[];
    /** @format date-time */
    due_date_from?: string;
    /** @format date-time */
    due_date_to?: string;
    /** @format int64 */
    due_mileage_min?: number;
    /** @format int64 */
    due_mileage_max?: number;
    /** @format float */
    mileage_min?: number;
    /** @format float */
    mileage_max?: number;
    /** @default "AND" */
    due_ranges_operator?: 'AND' | 'OR';
    active_maintenance?: boolean;
    /** When true, returns only items marked as solved by the customer. When false or null, the filter is not applied. */
    solved_by_customer?: boolean;
}

export interface MaintenanceDataPageResponse {
    content: MaintenanceDataItem[];
    page: PageMetadata;
}

export interface MaintenanceDataItem {
    /** Unique identifier of each resource e.g a brake-lining resource or maintenance-component. It can also be a component_id. */
    resource_id: ResourceId;
    cid?: number;
    component_slug?: string;
    title?: string;
    status: 'NEXT' | 'DUE' | 'OVERDUE' | 'UNKNOWN';
    due_at?: DueAt;
    due_in?: DueIn;
    measured_at: MeasuredAt;
    solved_by_customer?: boolean;
    proactive_maintenance: boolean;
    component_type: 'MAINTENANCE_COMPONENT' | 'CUSTOM_COMPONENT';
    asset: Asset;
    account: Account;
    workshop?: Workshop;
    recurrence?: Recurrence;
    appointment?: Appointment;
}

export interface DueAt {
    /** @format date-time */
    value?: string;
    state?: MaintenanceComponentDueState;
    /** When true, the frontends render month/year only instead of the full date. */
    has_month_precision?: boolean;
    /** Backend-computed. When true, the due-at date is not trustworthy for the (trusted) status and the frontends render it struck through. */
    is_inconsistent?: boolean;
}

export interface DueIn {
    /** @format int64 */
    value?: number;
    state?: MaintenanceComponentDueState;
    /** Backend-computed. When true, the due-in mileage is not trustworthy for the (trusted) status and the frontends render it struck through. */
    is_inconsistent?: boolean;
}

export interface Recurrence {
    type?: 'YEAR' | 'MONTH' | 'WEEK' | 'DISTANCE';
    value?: number;
}

export interface Appointment {
    id: string;
    /** @format date-time */
    date: string;
    workshop_id: string;
    workshop_name?: string;
}

export interface MaintenanceComponentPatchRequest {
    /** Whether the component was marked as solved by the customer. */
    is_solved_by_customer: boolean;
}

export interface MaintenanceComponentPageResponse {
    content: MaintenanceComponent[];
    page: PageMetadata;
}

export interface MaintenanceComponent {
    /** @format int32 */
    cid: number;
    /** Maintenance component slug */
    component?: string;
    due_state?: MaintenanceComponentDueState;
    previous_due_state?: MaintenanceComponentDueState;
    is_solved_by_customer?: boolean;
    source?: string;
    /** Remaining mileage until the component is due plus the underlying event. */
    due_in?: MaintenanceComponentDueIn;
    /** Calendar date on which the component becomes due plus the underlying event. */
    due_at?: MaintenanceComponentDueAt;
    /** Unique identifier of each resource e.g a brake-lining resource or maintenance-component. It can also be a component_id. */
    resource_id: ResourceId;
    account: Account;
    workshop?: Workshop;
    asset: Asset;
    measured_at: MeasuredAt;
}

/** Remaining mileage until the component is due plus the underlying event. */
export interface MaintenanceComponentDueIn {
    /** @format int64 */
    mileage_value?: number;
    mileage_state?: MaintenanceComponentDueState;
}

/** Calendar date on which the component becomes due plus the underlying event. */
export interface MaintenanceComponentDueAt {
    /** @format date-time */
    date_value?: string;
    date_state?: MaintenanceComponentDueState;
    has_month_precision?: boolean;
}

export declare namespace Brakes {
    /**
     * @description Retrieves paginated brakes data for assigned assets
     * @tags Brakes
     * @name GetBrakes
     * @summary Get brakes data
     * @request GET:/brakes
     * @secure
     * @response `200` `BrakePageResponse` Success
     * @response `400` `any`
     * @response `403` `any`
     * @response `default` `any`
     */
    export namespace GetBrakes {
        export type RequestParams = {};
        export type RequestQuery = {
            /**
             * Number of items per page
             * @min 1
             * @max 100
             * @default 20
             */
            page_size?: number;
            /**
             * Page number (zero-based)
             * @min 0
             * @default 0
             */
            page_number?: number;
            /**
             * Field to sort brakes results by
             * @default "vehicle"
             */
            sort_by?: 'vehicle' | 'vin' | 'customer' | 'workshop' | 'axlePosition' | 'left' | 'right';
            /**
             * Sort direction for results ordering. Accepted values: ASC, DESC (case-insensitive). Unrecognized values default to ASC.
             * @default "ASC"
             */
            sort_direction?: string;
            /** Filter results to only include data for the specified asset UUIDs */
            asset_ids?: string[];
            /** Filter results to only include data for assets belonging to the specified accounts. Usually a UUID, but non-UUID values may occur; treat as string. */
            account_ids?: string[];
            /** Filter results to only include data for assets assigned to the specified workshops */
            workshop_ids?: string[];
            /**
             * Minimum brake lining pressure value filter (inclusive)
             * @min 0
             * @max 100
             * @default 0
             */
            min?: number;
            /**
             * Maximum brake lining pressure value filter (inclusive)
             * @min 0
             * @max 100
             * @default 100
             */
            max?: number;
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = BrakePageResponse;
    }

    /**
     * @description Retrieves paginated grouped brakes data (left/right pairs) for assigned assets
     * @tags Brakes
     * @name GetGroupedBrakes
     * @summary Get grouped brakes data
     * @request GET:/brakes/grouped
     * @secure
     * @response `200` `GroupedBrakePageResponse` Success
     * @response `400` `any`
     * @response `403` `any`
     * @response `default` `any`
     */
    export namespace GetGroupedBrakes {
        export type RequestParams = {};
        export type RequestQuery = {
            /**
             * Number of items per page
             * @min 1
             * @max 100
             * @default 20
             */
            page_size?: number;
            /**
             * Page number (zero-based)
             * @min 0
             * @default 0
             */
            page_number?: number;
            /**
             * Field to sort brakes results by
             * @default "vehicle"
             */
            sort_by?: 'vehicle' | 'vin' | 'customer' | 'workshop' | 'axlePosition' | 'left' | 'right';
            /**
             * Sort direction for results ordering. Accepted values: ASC, DESC (case-insensitive). Unrecognized values default to ASC.
             * @default "ASC"
             */
            sort_direction?: string;
            /** Filter results to only include data for the specified asset UUIDs */
            asset_ids?: string[];
            /**
             * Minimum brake lining pressure value filter (inclusive)
             * @min 0
             * @max 100
             * @default 0
             */
            min?: number;
            /**
             * Maximum brake lining pressure value filter (inclusive)
             * @min 0
             * @max 100
             * @default 100
             */
            max?: number;
            /** Filter brakes by criticality status */
            status?: ('DANGER' | 'WARNING' | 'NORMAL')[];
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = GroupedBrakePageResponse;
    }
}

export declare namespace Assets {
    /**
     * @description Retrieves brakes data for a specific asset
     * @tags Brakes
     * @name GetBrakesForAsset
     * @summary Get brakes data for specific asset
     * @request GET:/assets/{assetId}/brakes
     * @secure
     * @response `200` `(Brake)[]` Success
     * @response `400` `any`
     * @response `403` `any`
     * @response `default` `any`
     */
    export namespace GetBrakesForAsset {
        export type RequestParams = {
            /**
             * assetId of the vehicle
             * @format uuid
             */
            assetId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {
            /** Token received in case of vin-search */
            'X-Auth'?: string;
        };
        export type ResponseBody = Brake[];
    }

    /**
     * @description Retrieves the latest maintenance event (timestamp and mileage) for a specific asset. Returns 204 when the asset has no event.
     * @tags Latest Events
     * @name GetLatestEventForAsset
     * @summary Get latest event for a specific asset
     * @request GET:/assets/{assetId}/latest-events
     * @secure
     * @response `200` `LatestEvent` Success
     * @response `204` `void` No latest event for the asset
     * @response `400` `any`
     * @response `403` `any`
     * @response `default` `any`
     */
    export namespace GetLatestEventForAsset {
        export type RequestParams = {
            /**
             * assetId of the vehicle
             * @format uuid
             */
            assetId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {
            /** Token received in case of vin-search */
            'X-Auth'?: string;
        };
        export type ResponseBody = LatestEvent;
    }

    /**
     * @description Retrieves all maintenance components and custom components for the given asset
     * @tags Maintenance Data
     * @name GetMaintenanceDataForAsset
     * @summary Get maintenance data for a specific asset
     * @request GET:/assets/{assetId}/maintenance-data
     * @secure
     * @response `200` `(MaintenanceDataItem)[]` Success
     * @response `400` `any`
     * @response `403` `any`
     * @response `default` `any`
     */
    export namespace GetMaintenanceDataForAsset {
        export type RequestParams = {
            /** @format uuid */
            assetId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {
            /** Token received in case of vin-search */
            'X-Auth'?: string;
        };
        export type ResponseBody = MaintenanceDataItem[];
    }

    /**
     * @description Retrieves all maintenance components for the given asset
     * @tags Maintenance Components
     * @name GetMaintenanceComponentsForAsset
     * @summary Get maintenance components for a specific asset
     * @request GET:/assets/{assetId}/maintenance-components
     * @secure
     * @response `200` `(MaintenanceComponent)[]` Success
     * @response `400` `any`
     * @response `403` `any`
     * @response `default` `any`
     */
    export namespace GetMaintenanceComponentsForAsset {
        export type RequestParams = {
            /**
             * assetId of the vehicle.
             * @format uuid
             */
            assetId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {
            /** Token received in case of vin-search */
            'X-Auth'?: string;
        };
        export type ResponseBody = MaintenanceComponent[];
    }
}

export declare namespace LatestEvents {
    /**
     * @description Retrieves the latest maintenance event (timestamp and mileage) for each assigned asset. Assets without event data are omitted.
     * @tags Latest Events
     * @name GetLatestEvents
     * @summary Get latest events for assigned assets
     * @request GET:/latest-events
     * @secure
     * @response `200` `LatestEventPageResponse` Success
     * @response `400` `any`
     * @response `403` `any`
     * @response `default` `any`
     */
    export namespace GetLatestEvents {
        export type RequestParams = {};
        export type RequestQuery = {
            /**
             * Number of items per page
             * @min 1
             * @max 100
             * @default 20
             */
            page_size?: number;
            /**
             * Page number (zero-based)
             * @min 0
             * @default 0
             */
            page_number?: number;
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = LatestEventPageResponse;
    }
}

export declare namespace MaintenanceData {
    /**
     * @description Retrieves paginated maintenance data combining maintenance components and custom components
     * @tags Maintenance Data
     * @name SearchMaintenanceData
     * @summary Search maintenance data
     * @request POST:/maintenance-data
     * @secure
     * @response `200` `MaintenanceDataPageResponse` Success
     * @response `400` `any`
     * @response `401` `void` Unauthorized
     * @response `403` `any`
     * @response `default` `any`
     */
    export namespace SearchMaintenanceData {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = MaintenanceDataSearchRequest;
        export type RequestHeaders = {};
        export type ResponseBody = MaintenanceDataPageResponse;
    }
}

export declare namespace MaintenanceComponents {
    /**
     * @description Retrieves paginated, fleet-wide maintenance components for assigned assets, with filtering and sorting
     * @tags Maintenance Components
     * @name GetMaintenanceComponents
     * @summary Get maintenance components data
     * @request GET:/maintenance-components
     * @secure
     * @response `200` `MaintenanceComponentPageResponse` Success
     * @response `400` `any`
     * @response `403` `any`
     * @response `default` `any`
     */
    export namespace GetMaintenanceComponents {
        export type RequestParams = {};
        export type RequestQuery = {
            /**
             * Number of items per page
             * @min 1
             * @max 100
             * @default 20
             */
            page_size?: number;
            /**
             * Page number (zero-based)
             * @min 0
             * @default 0
             */
            page_number?: number;
            /**
             * Field to sort maintenance components results by
             * @default "vehicle"
             */
            sort_by?: 'vehicle' | 'vin' | 'customer' | 'workshop' | 'status' | 'component' | 'due_at' | 'due_in';
            /**
             * Sort direction for results ordering. Accepted values: ASC, DESC (case-insensitive). Unrecognized values default to ASC.
             * @default "ASC"
             */
            sort_direction?: string;
            /** Filter results to only include data for the specified asset UUIDs */
            asset_ids?: string[];
            /** Filter results to only include data for assets belonging to the specified accounts. Usually a UUID, but non-UUID values may occur; treat as string. */
            account_ids?: string[];
            /** Filter results to only include data for assets assigned to the specified workshops */
            workshop_ids?: string[];
            /** Filter maintenance components by due state */
            status?: ('NEXT' | 'DUE' | 'OVERDUE' | 'UNKNOWN')[];
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = MaintenanceComponentPageResponse;
    }

    /**
     * @description Updates the solved-by-customer flag of a maintenance component and returns the updated component.
     * @tags Maintenance Components
     * @name PatchMaintenanceComponent
     * @summary Update a maintenance component
     * @request PATCH:/maintenance-components/{id}
     * @secure
     * @response `200` `MaintenanceComponent` Success
     * @response `400` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `default` `any`
     */
    export namespace PatchMaintenanceComponent {
        export type RequestParams = {
            /**
             * The component id of the maintenance component.
             * @format uuid
             */
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = MaintenanceComponentPatchRequest;
        export type RequestHeaders = {};
        export type ResponseBody = MaintenanceComponent;
    }
}

export declare namespace Workshops {
    /**
     * @description Retrieves workshop information by workshop ID.
     * @tags Workshops
     * @name GetWorkshop
     * @summary Get workshop details
     * @request GET:/workshops/{id}
     * @secure
     * @response `200` `Workshop` Success
     * @response `400` `any`
     * @response `403` `any`
     * @response `404` `void` Workshop not found
     * @response `default` `any`
     */
    export namespace GetWorkshop {
        export type RequestParams = {
            /** ID of the workshop. */
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = Workshop;
    }
}

export declare namespace Assignments {
    /**
     * @description Retrieves assignment information for a specific asset.
     * @tags Assignments
     * @name GetAssignmentForAsset
     * @summary Get assignment for asset
     * @request GET:/assignments/{id}
     * @secure
     * @response `200` `Assignment` Success
     * @response `400` `any`
     * @response `403` `any`
     * @response `404` `void` Assignment not found
     * @response `default` `any`
     */
    export namespace GetAssignmentForAsset {
        export type RequestParams = {
            /**
             * The Id of the asset of the vehicle.
             * @format uuid
             */
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = Assignment;
    }
}

export declare namespace Export {
    /**
     * @description Exports grouped brakes data as CSV file with localized headers
     * @tags Export
     * @name ExportBrakes
     * @summary Export brakes data as CSV
     * @request GET:/export/brakes
     * @secure
     * @response `200` `File` CSV file with brakes data
     * @response `default` `any`
     */
    export namespace ExportBrakes {
        export type RequestParams = {};
        export type RequestQuery = {
            /**
             * Field to sort brakes results by
             * @default "vehicle"
             */
            sort_by?: 'vehicle' | 'vin' | 'customer' | 'workshop' | 'axlePosition' | 'left' | 'right';
            /**
             * Sort direction for results ordering. Accepted values: ASC, DESC (case-insensitive). Unrecognized values default to ASC.
             * @default "ASC"
             */
            sort_direction?: string;
            /** Filter results to only include data for the specified asset UUIDs */
            asset_ids?: string[];
            /** Filter results to only include data for assets belonging to the specified accounts. Usually a UUID, but non-UUID values may occur; treat as string. */
            account_ids?: string[];
            /** Filter results to only include data for assets assigned to the specified workshops */
            workshop_ids?: string[];
            /**
             * Minimum brake lining pressure value filter (inclusive)
             * @min 0
             * @max 100
             * @default 0
             */
            min?: number;
            /**
             * Maximum brake lining pressure value filter (inclusive)
             * @min 0
             * @max 100
             * @default 100
             */
            max?: number;
            /** Filter brakes by criticality status */
            status?: ('DANGER' | 'WARNING' | 'NORMAL')[];
        };
        export type RequestBody = never;
        export type RequestHeaders = {
            /**
             * Language code for localized CSV headers and labels (e.g., en-GB, de-DE)
             * @default "en-GB"
             */
            'Accept-Language'?: string;
        };
        export type ResponseBody = File;
    }

    /**
     * @description Exports maintenance data as CSV file with localized headers and component labels
     * @tags Export
     * @name ExportMaintenanceData
     * @summary Export maintenance data as CSV
     * @request POST:/export/maintenance-data
     * @secure
     * @response `200` `File` CSV file with maintenance data
     * @response `401` `void` Unauthorized
     * @response `default` `any`
     */
    export namespace ExportMaintenanceData {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = MaintenanceDataSearchRequest;
        export type RequestHeaders = {
            /**
             * Language code for localized CSV headers and labels (e.g., en-GB, de-DE)
             * @default "en-GB"
             */
            'Accept-Language'?: string;
        };
        export type ResponseBody = File;
    }
}

export declare namespace UserSettings {
    /**
     * @description Retrieves user preferences for brake lining table (columns, filters, sorting). Returns defaults if not found.
     * @tags User Settings
     * @name GetBrakeLiningSettings
     * @summary Get brake lining table settings
     * @request GET:/user-settings/brake-lining
     * @secure
     * @response `200` `BrakeLiningSettings` Brake lining settings
     * @response `401` `any`
     * @response `default` `any`
     */
    export namespace GetBrakeLiningSettings {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = BrakeLiningSettings;
    }

    /**
     * @description Creates or updates user preferences for brake lining table
     * @tags User Settings
     * @name UpdateBrakeLiningSettings
     * @summary Update brake lining table settings
     * @request PUT:/user-settings/brake-lining
     * @secure
     * @response `200` `BrakeLiningSettings` Updated settings
     * @response `400` `any`
     * @response `401` `any`
     * @response `default` `any`
     */
    export namespace UpdateBrakeLiningSettings {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = BrakeLiningSettings;
        export type RequestHeaders = {};
        export type ResponseBody = BrakeLiningSettings;
    }

    /**
     * @description Retrieves user preferences for maintenance data table (columns, filters, sorting). Returns defaults if not found.
     * @tags User Settings
     * @name GetMaintenanceDataSettings
     * @summary Get maintenance data table settings
     * @request GET:/user-settings/maintenance-data
     * @secure
     * @response `200` `MaintenanceDataSettings` Maintenance data settings
     * @response `401` `any`
     * @response `default` `any`
     */
    export namespace GetMaintenanceDataSettings {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = MaintenanceDataSettings;
    }

    /**
     * @description Creates or updates user preferences for maintenance data table
     * @tags User Settings
     * @name UpdateMaintenanceDataSettings
     * @summary Update maintenance data table settings
     * @request PUT:/user-settings/maintenance-data
     * @secure
     * @response `200` `MaintenanceDataSettings` Updated settings
     * @response `400` `any`
     * @response `401` `any`
     * @response `default` `any`
     */
    export namespace UpdateMaintenanceDataSettings {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = MaintenanceDataSettings;
        export type RequestHeaders = {};
        export type ResponseBody = MaintenanceDataSettings;
    }
}
